module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/sidebar/userblock/userblock.component.scss
// module id = ./src/app/layout/sidebar/userblock/userblock.component.scss
// module chunks = main